import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table/Table";
import { useEffect } from "react";
import { fetchSensori } from "../../../features/sensori/sensoriThunk";

const SensoriMezzi = () => {
    const tableData = useSelector((state) => state.sensori?.sensori);
    const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
    const dispatch = useDispatch()
    const columns = [
        { field: "sensore_name", headerName: "Nome del dispositivo", width: 381 },
        { field: "sensore_tipo", headerName: "Tipo", width: 189 },
        { field: "modelllo", headerName: "Modello", width: 189 },
        { field: "matricola", headerName: "Matricola", width: 189 },
        { field: "sensore_gps", headerName: "Posizione GPS", width: 147 },
        { field: "data_installazione", headerName: "Data installazione", width: 174 },
        { field: "ultimo_agginornamento", headerName: "Ultimo aggiornamento", width: 174 },
        { field: "status", headerName: "Stato", width: 174 },
        { field: "azioni", headerName: "Azioni", width: 100, sortable: false }
    ];

    useEffect(() => {
        dispatch(fetchSensori())
    }, [dispatch, selectSelectedCompany])

    return (
        <>
            <div className="pageTemplate">
                <Table
                    data={tableData}
                    columns={columns}
                    navData={"strucutreSensori"}
                    deleteFunctions={"deleteSensore"}
                />
            </div>
        </>
    );
};

export default SensoriMezzi;
